import { getEnv } from "../env";

export const getORPCBaseUrl = () => getEnv().baseUrl + getEnv().rpcApiPath;
